export default __webpack_public_path__ + "static/media/Connectivity-My-DDD-Platform.f64c3f9b.jpg";